import React, { useEffect, useState } from 'react';
import { loadingBar } from '../../../lib/loadingBar';

export const TopLoadingBar: React.FC = () =>
{
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() =>
  {
    return loadingBar.subscribe(setIsLoading);
  }, []);

  useEffect(() =>
  {
    let progressTimer: ReturnType<typeof setInterval> | null = null;

    if (isLoading)
    {
      setLeaving(false);
      setVisible(true);
      setProgress(10);

      progressTimer = setInterval(() =>
      {
        setProgress(prev =>
        {
          if (prev >= 85)
          {
            if (progressTimer) clearInterval(progressTimer);
            return 85;
          }
          return prev + Math.random() * 10;
        });
      }, 300);
    }
    else if (visible)
    {
      setProgress(100);
      const hideTimer = setTimeout(() =>
      {
        setLeaving(true);
        setTimeout(() =>
        {
          setVisible(false);
          setProgress(0);
          setLeaving(false);
        }, 300);
      }, 200);
      return () => clearTimeout(hideTimer);
    }

    return () =>
    {
      if (progressTimer) clearInterval(progressTimer);
    };
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 99999,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${progress}%`,
          background: 'linear-gradient(to right, #e53e3e, #fc8181)',
          transition: leaving ? 'width 0.3s ease, opacity 0.3s ease' : 'width 0.4s ease',
          opacity: leaving ? 0 : 1,
          boxShadow: '0 0 6px rgba(229, 62, 62, 0.6)',
        }}
      />
    </div>
  );
};
